import React from 'react'
import Videos from '../Videos';
import { useHistory } from 'react-router-dom'

const DBDA_NA = React.memo(() => {

    const history = useHistory();

    const nextRoute = () => {
        history.push('/question3')
    }

    const title = "NA-Numerical ability";
    const url = "https://careers4me.in/videos/Numerical_ability.mp4";

    return (
        <Videos title={title} url={url} onPress={nextRoute} />
    )
});

export default DBDA_NA